const report = {
    columns: [],
    data: [],
    footer: [],
    id: "",
    name: "",
};

export { report };
